import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Offcanvas,
  Row,
  Accordion,
} from "react-bootstrap";
import { Images } from "./Images";
import { NavLink } from "react-router-dom";

const JoinFlashChain = ({ cmsLits }) => {

  const [value1, setValue1] = useState()

  useEffect(() => {
    if (cmsLits) {
      setValue1(cmsLits.find((value) => (value.identifier == 'Join Sector-8 now')))
    }
  }, [cmsLits]);


  return (
    <div className="join_sector">
      <Container className="custom_container">
        <img src={Images.leftshade} alt="Left shade" className="img-fluid shadeimg leftshadeimg" />
        <img src={Images.rightshade} alt="Right shade" className="img-fluid shadeimg rightshadeimg" />
        <div className="content">
          <div className="contentinner">
            <img src={Images.joinsector} alt="Join Sector-8" className="img-fluid centerimg" />
            <p className="title_txt hacked-font title_txttwo">{value1?.heading}</p>
            <p className="paracontent t-grey auttera-font">
              {value1?.content}
            </p>
            <Button className="get_started_btn cmn_blueBtn imgbtn hacked-font btn btn-primary">Get Started</Button>
          </div>
        </div>
        <img src={Images.wmatic} alt="Coins" className="img-fluid coinimg coinimgone" />
        <img src={Images.chainlink} alt="Coins" className="img-fluid coinimg coinimgtwo" />
        <img src={Images.weth} alt="Coins" className="img-fluid coinimg coinimgthree" />
        <img src={Images.tether} alt="Coins" className="img-fluid coinimg coinimgfour" />
        <img src={Images.aave} alt="Coins" className="img-fluid coinimg coinimgfive" />
        <img src={Images.chainlink} alt="Coins" className="img-fluid coinimg coinimgsix" />
        <img src={Images.usd} alt="Coins" className="img-fluid coinimg coinimgseven" />
        <img src={Images.frax} alt="Coins" className="img-fluid coinimg coinimgeight" />
      </Container>
    </div>
  );
};

export default JoinFlashChain;
